<template>
<!--------------------------------------- Slots overview ------------------------------------------
  item.actions            This slot is used to display the actions for each item in the table.
                          Props: item

------------------------------------------ Emits overview -----------------------------------------
  edit                    This event is emitted when the edit action is clicked.
                          Payload: item
  delete                  This event is emitted when the delete action is clicked.
                          Payload: item
-------------------------------------------------------------------------------------------------->
  <v-data-table
    :headers="communityHeaders"
    :items="associationData"
    :hide-default-footer="true"
  >
    <template #item.#text="{ item }">
      <div v-html="item['#text']"></div>
    </template>
    <template #item.actions="{ item }">
      <slot name="item.actions" :item="item">
        <AdSpeedDial v-if="!readonly" direction="left">
          <AdSpeedOption type="edit" @click="$emit('edit', item)"/>
          <AdSpeedOption type="delete" @click="$emit('delete', item)" />
        </AdSpeedDial>
      </slot>
    </template>
  </v-data-table>
</template>

<script>
export default {
  name: 'MyCommunityAssociationsTable',
  props: {
    community: {
      type: Object,
      required: true
    },
    readonly: Boolean
  },
  computed: {
    associationData () {
      return this.community.associations?.[0]?.association?.[0]?.data || []
    },
    communityHeaders () {
      const headers = [
        { text: this.$t('type'), value: 'type', width: '50%' },
        { text: this.$t('value'), value: '#text', width: '50%' }
      ]
      if (!this.readonly) {
        headers.push({ text: '', value: 'actions', sortable: false, align: 'right' })
      }
      return headers
    }
  }
}
</script>
